import { getActiveLoan, getLoanBySlug } from 'api';
import type { IActiveLoan } from 'interfaces';
import type { AppDispatch } from 'store/store';
import { cleanupLoan, updateLoanAction } from 'store/slices/loan';
import { updateUserAction } from 'store/slices/user';
import { isLoanNotFoundError } from './apiErrors';

interface SyncActiveLoanParams {
  dispatch: AppDispatch;
  partialView?: boolean;
  slug?: string;
}

export type SyncActiveLoanResult = { status: 'updated'; loan: IActiveLoan } | { status: 'not_found' };

export const syncActiveLoanFromServer = async ({
  dispatch,
  partialView = false,
  slug,
}: SyncActiveLoanParams): Promise<SyncActiveLoanResult> => {
  try {
    if (partialView && slug) {
      const { data } = await getLoanBySlug(slug);
      const loanData: IActiveLoan = { ...data.data, real_maturity_date: data.data.maturity_date };

      dispatch(updateLoanAction({ loan: loanData }));

      return { status: 'updated', loan: loanData };
    }

    const loanData = (await getActiveLoan()) as IActiveLoan;
    dispatch(updateLoanAction({ loan: loanData }));

    return { status: 'updated', loan: loanData };
  } catch (error: unknown) {
    if (isLoanNotFoundError(error)) {
      dispatch(cleanupLoan());
      dispatch(updateUserAction({ user: { has_active_loan: false } }));
      return { status: 'not_found' };
    }

    throw error;
  }
};
